/* The History panel: versions and the event log (staff only). */
.save {
  margin: 4px 0 18px;
}
.save label {
  display: block;
  font-size: 13px;
  font-weight: 700;
  color: var(--ink);
  margin-bottom: 6px;
}
.saveRow {
  display: flex;
  gap: 8px;
}
.saveRow input {
  flex: 1 1 auto;
  min-width: 0;
  border: 1px solid var(--border-strong);
  border-radius: 9px;
  padding: 8px 10px;
  font: inherit;
  font-size: 14px;
}
.heading {
  font-size: 15px;
  margin: 14px 0 8px;
}
.empty {
  font-size: 14px;
  color: var(--body);
}
.table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}
.table th {
  text-align: left;
  font-size: 12px;
  color: var(--body);
  font-weight: 700;
  padding: 6px 8px;
  border-bottom: 1px solid var(--border);
}
.table td {
  padding: 8px;
  border-bottom: 1px solid var(--border);
  vertical-align: top;
}
.label {
  display: block;
  font-size: 12px;
  color: var(--body);
}
.download {
  color: var(--blue-d);
  font-weight: 700;
}
.events {
  list-style: none;
  margin: 0;
  padding: 0;
  font-size: 13px;
  max-height: 260px;
  overflow-y: auto;
}
.events li {
  display: grid;
  grid-template-columns: 150px 1fr;
  gap: 2px 12px;
  padding: 6px 0;
  border-bottom: 1px solid var(--border);
}
.when {
  color: var(--body);
}
.what {
  color: var(--ink);
  overflow-wrap: anywhere;
}
.who {
  grid-column: 2;
  color: var(--body);
  overflow-wrap: anywhere;
}
.error {
  color: var(--ink);
  background: var(--amber-bg);
  border-left: 3px solid var(--amber-line);
  padding: 6px 10px;
  margin: 8px 0 0;
  font-size: 13px;
}
@media (max-width: 560px) {
  .events li {
    grid-template-columns: 1fr;
  }
  .who {
    grid-column: 1;
  }
}
